<template>
  <div class='landing'>
    <div>      
      <img src="@/assets/images/sdfc.png" alt="" width="185" class="logo">        
      <div>
      <h2 v-if="$store.state.repId == '23'">¡Conviértete en Abonado de Temporada para San Diego FC!</h2>
      <h2 v-else>Become a Season Ticket Member of San Diego FC!</h2>
      <p v-if="$store.state.repId == '23'">Agenda tu cita abajo para hablar con un representante de San Diego FC y aprende más sobre los beneficios de ser un Miembro Fundador del club, precios y disponibilidad de asientos. </p>
      <p v-else>Book your appointment below to speak with an SDFC sales representative and learn more about the benefits of being a San Diego FC Founding Member, pricing, and availability.</p>
      <slot></slot>    
      </div>
      <Countdown />
    </div>    
  </div>
</template>

<script>
import Countdown from '@/components/Countdown.vue'
export default {
  name:'Landing',
  components : {
    Countdown
  }
}
</script>

<style lang="scss" scoped>
.logo {
  padding-bottom:40px;
  margin-bottom:20px;
  border-bottom: 1px solid #FFFFFF;;
}
.title {
  font-size: 2.375rem;
  text-transform: uppercase;
  color: var(--white);
  margin-top:45px;
}
h1, p {
  margin:5px 0;
  color: var(--white);
  font-size:2.563rem;
  font-weight: 300;
  line-height: 0.9122;
  max-width: 490px;    
  text-transform: uppercase;  
}
h1 {    
  font-weight: 600;
  margin-bottom: 27px;  
}
h2 {
  color: var(--white);
  text-align: center;
  font-size: 24px;
  line-height: 1;
  letter-spacing: 0.72px;
  font-style: bold;
  text-transform: uppercase;
}
.welcome {
  border-bottom:1px solid var(--white);
  padding-bottom: 30px;    
}
p {
text-align: center;
font-family: "Modern Era";
font-size: 14px;
line-height: 1.42;
text-transform: unset;
margin:0 auto;
padding:0.81rem 0;
}
.landing {
  flex-grow: 1;
  display: grid;
  place-items: center;  
  position: relative;
  background:url('~@/assets/images/welcome.jpg');
  background-size: cover;
  background-position: bottom center;
  box-sizing: border-box;  
    padding:50px;    
  @media (min-width:600px) {
    padding:200px;    
  }
  > div {    
    position: relative;
  }  
}
</style>